import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { MySubscriptionsPage } from '@/features/subscriptions/MySubscriptionsPage';
import { MobileMySubscriptions } from '@/features/subscriptions/mobile/MobileMySubscriptions';

/**
 * Gli abbonamenti a proprio nome (e quelli del team, per chi ne coordina). Pagina a sé come il
 * mezzo proprio: è un dato personale con una scadenza, non una richiesta da approvare.
 */
export const Route = createFileRoute('/_app/my-subscriptions')({ component: MySubscriptionsRoutePage });

/** Selettore mobile/desktop: sul telefono la tabella diventa una lista di card. */
function MySubscriptionsRoutePage() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileMySubscriptions /> : <MySubscriptionsPage />;
}
